/** Aligns wizard context, progress, section cards, and nav with the product width. */
export const MAINTENANCE_PROTOCOL_COLUMN_CLASS = 'mx-auto w-full max-w-2xl';

/** PDF pages need the full content width; the form column is too narrow to draw on. */
export const MAINTENANCE_PROTOCOL_PDF_COLUMN_CLASS = 'w-full';
